import { t } from "i18next"

export function getBasePopup(): any {
    return {
        "page": {
            "body": {
                "container": {
                    "style": {
                        "background-color": "#FFFFFF"
                    }
                },
                "content": {
                    "computedStyle": {
                        "linkColor": "#0b4341",
                        "messageBackgroundColor": "transparent",
                        "messageWidth": "500px",
                        "messageWidthMobile": "250px"
                    },
                    "style": {
                        "color": "#000000",
                        "font-family": "Montserrat, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif"
                    }
                },
                "type": "mailup-bee-page-properties",
                "webFonts": [
                    {
                        "fontFamily": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                        "name": "Montserrat",
                        "url": "https://fonts.googleapis.com/css?family=Montserrat"
                    }
                ]
            },
            "description": "",
            "rows": [
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "height": 42,
                                            "width": 52
                                        },
                                        "heading": {
                                            "style": {
                                                "color": "#0b4341",
                                                "direction": "ltr",
                                                "font-family": "inherit",
                                                "font-size": "32px",
                                                "font-weight": "400",
                                                "letter-spacing": "0px",
                                                "line-height": "120%",
                                                "link-color": "#E01253",
                                                "text-align": "center"
                                            },
                                            "text": "<strong>" + t("popup-default-content-title") + "</strong>",
                                            "title": "h2"
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "text-align": "center",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-heading",
                                    "uuid": "a787090e-978c-403f-ac5c-1795612eca94"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false,
                                            "iconHeight": "64px",
                                            "iconSpacing": {
                                                "padding-bottom": "5px",
                                                "padding-left": "5px",
                                                "padding-right": "5px",
                                                "padding-top": "0px"
                                            },
                                            "itemsSpacing": "0px"
                                        },
                                        "iconsList": {
                                            "icons": [
                                                {
                                                    "height": "1402px",
                                                    "href": "",
                                                    "id": "ccf41458-368f-4633-9fd2-d6da0eb396f9",
                                                    "image": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/7286/Group_1__1_.png",
                                                    "target": "_self",
                                                    "text": "",
                                                    "textPosition": "right",
                                                    "width": "1902px"
                                                }
                                            ]
                                        },
                                        "style": {
                                            "color": "#000000",
                                            "font-family": "inherit",
                                            "font-size": "14px",
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "text-align": "center"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-icons",
                                    "uuid": "26bafe98-98f9-46d7-a537-c8b91d86934e"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnAmp": false,
                                            "hideContentOnDesktop": false,
                                            "hideContentOnHtml": false,
                                            "hideContentOnMobile": false
                                        },
                                        "paragraph": {
                                            "computedStyle": {
                                                "linkColor": "#0b4341"
                                            },
                                            "html": "<p style=\"word-break:break-word;\"><span>" + t("popup-default-content-description") + "</span></p>",
                                            "style": {
                                                "color": "#111111",
                                                "font-family": "inherit",
                                                "font-size": "16px",
                                                "line-height": "150%",
                                                "text-align": "center"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "15px"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-paragraph",
                                    "uuid": "5bfdb356-2153-4d91-a2ab-77716c20ded3"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "10px",
                                "padding-left": "15px",
                                "padding-right": "15px",
                                "padding-top": "30px"
                            },
                            "uuid": "3369eaaa-e213-48c5-855f-40fda601d913"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center",
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false
                                        },
                                        "form": {
                                            "structure": {
                                                "attributes": {
                                                    "accept-charset": "UTF-8",
                                                    "action": "",
                                                    "autocomplete": "on",
                                                    "enctype": "multipart/form-data",
                                                    "method": "post",
                                                    "novalidate": false,
                                                    "target": "_self"
                                                },
                                                "description": "",
                                                "fields": {
                                                    "email": {
                                                        "attributes": {
                                                            "required": true
                                                        },
                                                        "canBeModified": true,
                                                        "canBeRemovedFromLayout": false,
                                                        "label": t("general-email"),
                                                        "options": null,
                                                        "removeFromLayout": false,
                                                        "type": "email"
                                                    },
                                                    "submit_button": {
                                                        "attributes": {
                                                            "name": "submit_button",
                                                            "value": t("general-submit")
                                                        },
                                                        "canBeModified": true,
                                                        "canBeRemovedFromLayout": false,
                                                        "options": null,
                                                        "removeFromLayout": false,
                                                        "type": "submit"
                                                    },
                                                },
                                                "layout": [
                                                    [
                                                        "email"
                                                    ],
                                                    [
                                                        "submit_button"
                                                    ]
                                                ],
                                                "title": ""
                                            },
                                            "style": {
                                                "buttons": {
                                                    "backgroundColor": "#0b4341",
                                                    "border-bottom": "0px solid transparent",
                                                    "border-left": "0px solid transparent",
                                                    "border-radius": "4px",
                                                    "border-right": "0px solid transparent",
                                                    "border-top": "0px solid transparent",
                                                    "color": "#ffffff",
                                                    "line-height": "200%",
                                                    "max-width": "100%",
                                                    "outer": {
                                                        "display": "block",
                                                        "flexGrow": 1,
                                                        "padding-bottom": "0px",
                                                        "padding-left": "0px",
                                                        "padding-right": "0px",
                                                        "padding-top": "25px"
                                                    },
                                                    "padding-bottom": "5px",
                                                    "padding-left": "20px",
                                                    "padding-right": "20px",
                                                    "padding-top": "5px",
                                                    "text-align": "center",
                                                    "width": "100%"
                                                },
                                                "fields": {
                                                    "backgroundColor": "#ffffff",
                                                    "border-bottom": "1px solid transparent",
                                                    "border-left": "1px solid transparent",
                                                    "border-radius": "4px",
                                                    "border-right": "1px solid transparent",
                                                    "border-top": "1px solid transparent",
                                                    "color": "#111111",
                                                    "outlineColor": "#f2f7f9",
                                                    "padding-bottom": "5px",
                                                    "padding-left": "5px",
                                                    "padding-right": "5px",
                                                    "padding-top": "5px"
                                                },
                                                "labels": {
                                                    "color": "#111111",
                                                    "font-style": "",
                                                    "font-weight": "",
                                                    "label-position": "top",
                                                    "line-height": "200%",
                                                    "text-align": "left"
                                                }
                                            }
                                        },
                                        "style": {
                                            "background-color": "transparent",
                                            "font-family": "inherit",
                                            "font-size": "18px",
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "text-align": "center",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-form",
                                    "uuid": "242117f1-b520-4c9e-a6b5-3ca1cb85a144"
                                }
                            ],
                            "style": {
                                "background-color": "#f2f7f9",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "50px",
                                "padding-left": "15px",
                                "padding-right": "15px",
                                "padding-top": "50px"
                            },
                            "uuid": "2c82db2e-530e-4df7-8476-274c44a363d2"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false,
                            "verticalAlign": "top"
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "910px"
                        }
                    },
                    "empty": false,
                    "locked": false,
                    "synced": false,
                    "type": "one-column-empty",
                    "uuid": "53d3d1e1-207a-46b2-acfc-19812ea6b743"
                }
            ],
            "template": {
                "name": "template-base",
                "type": "basic",
                "version": "2.0.0"
            },
            "title": ""
        },
        "comments": {}
    }
}